<template>
    <div class="dashboard-container">
        <side-bar />
        <div class="main-content">
            <!-- BreadCrumb datapage -->
            <div class="container">
                <component src="https://c2hbe361.caspio.com/dp/76bfd000aec87c7310e84ca7b0b5/emb" :is="'script'">
                </component>
            </div>
            <h2>Transfers</h2>
            <hr class="h2" />

            <div class="flex-container">
                <div class="left-section">
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd000da8061cfd2a5462899dd/emb" :is="'script'">
                        </component>
                    </div>
                    <!-- submit button -->
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd000b9c57c5351d44e20a46a/emb" :is="'script'">
                        </component>
                    </div>
                </div>
                <div class="right-section">
                    <div class="container">
                        <component src="https://c2hbe361.caspio.com/dp/76bfd000155ff238df2743998991/emb" :is="'script'">
                        </component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '../SideBar.vue'

export default {
    name: 'PartnerBotTransfers',
    components: {
        SideBar
    }
}
</script>
<style scoped>
.flex-container {
    display: flex;
    flex-direction: row;
}

.right-section {
    max-width: 420px;
}
</style>
